/**
 * @generated SignedSource<<0df1f1a7da6d9c42eaf37b1ba70ce541>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountCodeColumn_Fragment$data = {
  readonly extension: {
    readonly accountCode?: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "accountCodeColumn_Fragment";
};
export type accountCodeColumn_Fragment$key = {
  readonly " $data"?: accountCodeColumn_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountCodeColumn_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountCodeColumn_Fragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "userExtensionKind",
          "value": "InfectopharmUserExtension"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountCode",
              "storageKey": null
            }
          ],
          "type": "InfectopharmUserExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "35500e7a88beb2efc9b868b761ec564b";

export default node;
